import { useEffect } from 'react'

import {
  configureBackgroundMusic,
  syncBackgroundMusicVisibility,
  unlockBackgroundMusic,
} from './music.js'

export function useBackgroundMusic(active: boolean, enabled: boolean): void {
  useEffect(() => {
    configureBackgroundMusic({ active, enabled })
  }, [active, enabled])

  useEffect(() => {
    if (typeof window === 'undefined') return undefined
    const unlock = (): void => unlockBackgroundMusic()
    const visibility = (): void => syncBackgroundMusicVisibility()
    window.addEventListener('pointerdown', unlock, { passive: true })
    document.addEventListener('visibilitychange', visibility)
    return () => {
      window.removeEventListener('pointerdown', unlock)
      document.removeEventListener('visibilitychange', visibility)
    }
  }, [])
}
